import React from 'react'
import usePortManager from '../hooks/use-port-manager'
import { observer } from 'mobx-react'

function getWindowStyle (row, column, portManager) {
  const [type, rows, columns] = portManager.getWindowProperties()
  const portWidth = portManager.getPortWidth()
  const portHeight = portManager.getPortHeight()

  let windowTypeWidth, windowTypeHeight, windowTypeRowHeight, windowTypeColumnWidth, windowPositionFromBottom

  switch (type) {
    case '90w':
      windowTypeWidth = 77.5
      windowTypeHeight = 43
      windowTypeRowHeight = 67.5
      windowTypeColumnWidth = 100
      windowPositionFromBottom = 150
      break
    case 's80w':
      windowTypeWidth = 77.5
      windowTypeHeight = 33
      windowTypeRowHeight = 54.5
      windowTypeColumnWidth = 100
      windowPositionFromBottom = 123
      break
    case '90m':
      windowTypeWidth = 100
      windowTypeHeight = 67.5
      windowTypeRowHeight = 67.5
      windowTypeColumnWidth = 100
      windowPositionFromBottom = 134
  }

  const totalWidth = windowTypeWidth + (windowTypeColumnWidth * (columns - 1))

  const posLeftBase = (portWidth / 2) - (totalWidth / 2)
  const posLeft = posLeftBase + (column * windowTypeColumnWidth)
  const posLeftPercentage = (posLeft / portWidth) * 100

  const posBottom = windowPositionFromBottom + (row * windowTypeRowHeight)
  const posBottomPercentage = (posBottom / portHeight) * 100

  const cssWidth = (windowTypeWidth / portWidth) * 100
  const cssHeight = (windowTypeHeight / portHeight) * 100

  return {
    bottom: posBottomPercentage + '%',
    left: posLeftPercentage + '%',
    width: cssWidth + '%',
    height: cssHeight + '%',
  }
}

function getWindows () {
  const portManager = usePortManager()

  let windows = []

  if (portManager.getWindowProperties() !== null) {
    const [type, rows, columns] = portManager.getWindowProperties()

    for (let i = 0; i < rows; i++) {
      for (let j = 0; j < columns; j++) {
        let windowStyle = getWindowStyle(i, j, portManager)
        windows.push(windowStyle)
      }
    }

  }

  return windows
}

function WindowsLayer (props) {
  const portManager = usePortManager()

  const windows = getWindows()

  if (windows.length < 1) return null

  const size = portManager.getPortImageSize()
  const [type, rows, columns] = portManager.getWindowProperties()

  const base_url = window.main_theme_objects.assets_url
  const src = base_url + 'port-images/windows/' + type + '.png'
  const className = props.className ? props.className : null

  return (
    <React.Fragment>
      {windows.map(function (windowStyle, index) {
          return (
            <img
              key={index}
              src={src}
              data-name={props.name}
              className={className + ' ' + size}
              style={windowStyle}
            />
          )
        }
      )}
    </React.Fragment>
  )
}

export default observer(WindowsLayer)